import { jsx as e } from "react/jsx-runtime";
import { useVideo as t } from "../../hook/useVideo.js";
import i from "../../context/PlayerContext.js";
const d = ({ children: r }) => {
  const o = t();
  return /* @__PURE__ */ e(i.Provider, { value: o, children: r });
};
export {
  d as default
};
